import {z} from 'zod';

// Base schema for all cards
const baseCardSchema = z.object({
  cardId: z.number().describe('The ID of the card'),
  name: z.string().describe('The name of the card'),
  description: z.string().describe('A brief description of what this card does'),
});

const addOrUpdateCardInputSchema = z.object({
  prompt: z.string().describe('The prompt to use for the card'),
  cardId: z
    .number()
    .nullable()
    .describe(
      'This parameter is only used when updating an existing card. It is the ID of the card to update. When creating a new card, you MUST NOT provide a card ID. If you are creating a new card, you MUST leave this field empty.',
    ),
});

export {addOrUpdateCardInputSchema, baseCardSchema};
